module.exports = __webpack_public_path__ + "img/cloud.c8d0a118.svg";